import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import defaultDesignThemeJson from './themes/default.json';
import { useContextTokens } from "./ThemeProvider.mjs";
var defaultDesignThemeTokens = defaultDesignThemeJson;
var zIndexStackingContext = /*#__PURE__*/React.createContext(0);
export var useZIndexStacking = function useZIndexStacking(designToken) {
  var contextTokens = useContextTokens();
  var parentContextValue = React.useContext(zIndexStackingContext);
  var contextValue = React.useMemo(function () {
    if (!designToken) return parentContextValue;
    var tokenName = designToken.startsWith('--intergalactic-') ? designToken : "--intergalactic-".concat(designToken);
    var tokenValue = parseInt((contextTokens === null || contextTokens === void 0 ? void 0 : contextTokens[tokenName]) || defaultDesignThemeTokens[tokenName], 10);
    if (Number.isNaN(tokenValue)) return parentContextValue;
    return parentContextValue + tokenValue;
  }, [designToken, contextTokens, parentContextValue]);
  return contextValue;
};
export var ZIndexStackingContextProvider = function ZIndexStackingContextProvider(_ref) {
  var designToken = _ref.designToken,
    children = _ref.children;
  var contextValue = useZIndexStacking(designToken);
  return /*#__PURE__*/React.createElement(zIndexStackingContext.Provider, {
    value: contextValue
  }, children);
};
export var zIndexStackingEnhance = function zIndexStackingEnhance(designToken) {
  return function (props) {
    var other = _extends({}, (_objectDestructuringEmpty(props), props));
    var parentZIndexStacking = useZIndexStacking(designToken);
    return _objectSpread(_objectSpread({}, other), {}, {
      parentZIndexStacking: parentZIndexStacking
    });
  };
};
//# sourceMappingURL=zIndexStacking.mjs.map